import { afterLoadWhenIdle } from "@/utils/after-load-idle";

// The classic Web Widget finds its key through this element id; keep it.
export const ZENDESK_SNIPPET_ID = 'ze-snippet';
export const ZENDESK_SNIPPET_URL = 'https://static.zdassets.com/ekr/snippet.js?key=f4e9e105-48fc-466f-a861-a57ed4b1a949';

/**
 * Below PrimeVue's modal layer (Toast, Drawer and Dialog stack from 1100) and its overlays (1000). Zendesk's default
 * sits above everything, so the launcher floated over the full-screen content slide-over on phones and an open widget
 * hid every toast. Toasts are top-right, and the bottom-left overlays (the update prompt, and the install card that
 * waits for it) keep their buttons clear of the launcher's default bottom-right offset: the prompt's are centred on a
 * phone and at its left from sm, and on a phone the install card leaves the right 5rem free (PwaInstallCard.vue).
 * Only the stacking needed changing. It puts the launcher above both, so a bottom-left overlay that grows into that
 * corner is covered there.
 */
export const ZENDESK_Z_INDEX = 999;

declare global {
    interface Window {
        zESettings?: Record< string, unknown >;
    }
}

/** Adds the snippet once; the snippet then loads the widget (~240 KB brotli, ~770 KB of JS to run). */
export function injectZendeskWidget(): void {
    if ( document.getElementById( ZENDESK_SNIPPET_ID ) ) return;

    window.zESettings = { webWidget: { zIndex: ZENDESK_Z_INDEX } };

    const script = document.createElement( 'script' );
    script.id = ZENDESK_SNIPPET_ID;
    script.async = true;
    script.src = ZENDESK_SNIPPET_URL;
    document.body.appendChild( script );
}

/**
 * UX roadmap #26: the support launcher stays on every page, but its script no longer loads with the app. It was an
 * async <script> in index.html, so the widget downloaded and ran during startup on every visit, alongside the entry
 * chunk and the first API calls, although nothing in the app talks to it. It now loads after `load`, when idle.
 */
export function scheduleZendeskWidget(): () => void {
    return afterLoadWhenIdle( injectZendeskWidget );
}
